import Toggletip, {
  ToggletipButton,
  ToggletipContent,
} from '@carbon/react/es/components/Toggletip';
import Help from '@carbon/icons-react/es/Help';

import { useT, type MessageKey } from '../i18n/index.js';

/** Alignements Carbon utiles ; on n'expose que ceux dont on se sert pour rester simple. */
type HelpAlign =
  'top' | 'top-start' | 'top-end' | 'bottom' | 'bottom-start' | 'bottom-end' | 'left' | 'right';

/**
 * Bulle d'aide réutilisable : une pastille « ? » qui révèle, au clic ou au clavier, un court texte
 * informatif (i18n). On s'appuie sur le `Toggletip` de Carbon — accessible (bouton focusable, contenu
 * annoncé à l'ouverture, fermeture Échap) et adapté au tactile, contrairement à un survol seul. Le
 * texte vient **toujours** d'une clé i18n : l'aide est traduite fr/en/uk comme le reste.
 */
export function HelpHint({
  textKey,
  align = 'top',
}: {
  /** Clé i18n du texte d'aide affiché dans la bulle. */
  textKey: MessageKey;
  align?: HelpAlign;
}) {
  const t = useT();
  return (
    <Toggletip align={align} className="ddp-help">
      <ToggletipButton label={t('help.label')}>
        <Help size={16} />
      </ToggletipButton>
      <ToggletipContent>
        <p className="ddp-help__text">{t(textKey)}</p>
      </ToggletipContent>
    </Toggletip>
  );
}
